/**
 * https://app.pacarion.com links that should open the iOS app when it is installed.
 * The same URLs keep working in the browser when it is not.
 *
 * Covered:
 * - /login?homeowner_code=  invite and account set-up
 * - /signup?invite=         team invite
 * - /?login=homeowner       homeowner dashboard
 * - /?login=homeowner&section=projects  project checklist
 * - /?login=homeowner&section=tasks     task list
 * - /?login=agent           agent dashboard
 * - /?login=agent&section=tasks&client=&task=  a homeowner's task
 * - /?login=agent&section=settings#billing     billing (web only manages the plan)
 * - /tasks/:id?action=&token=  email task actions
 * - /property and /contacts
 * - /join?ref=            friend invite
 */

const { taskActionFromLocation } = require('./appPaths');
const { readAgentLink } = require('./agentLinks');

const APPLE_TEAM_ID = 'BTZDL87F77';
const IOS_BUNDLE_ID = 'com.pacarion.pacarionapp';

function readIncomingAppUrl(href) {
  const url = new URL(String(href || '/'), 'https://app.pacarion.com');
  const params = url.searchParams;
  const homeownerCode = String(params.get('homeowner_code') || '').trim();
  const teamInvite = String(params.get('invite') || '').trim();
  const login = String(params.get('login') || '').trim().toLowerCase();
  return {
    pathname: url.pathname || '/',
    search: url.search || '',
    hash: url.hash || '',
    homeownerCode,
    teamInvite,
    login: login === 'homeowner' || login === 'agent' ? login : '',
    section: String(params.get('section') || '').trim().toLowerCase(),
    agentLink: readAgentLink(url.search),
    task: taskActionFromLocation(url.pathname, url.search),
    joinRef: (url.pathname || '/').replace(/\/+$/, '') === '/join'
      ? String(params.get('ref') || '').trim()
      : '',
  };
}

module.exports = {
  APPLE_TEAM_ID,
  IOS_BUNDLE_ID,
  readIncomingAppUrl,
};
